import { useDispatch, useSelector } from 'react-redux';
import { getWorksheetGridCommonDataProviderProps } from './providerProps';
import { InjectedPropsProvider } from '../../../Core/InjectedPropsContext';
import { actions } from '../../../../Data/ReduxViewModels/WorksheetGrid';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';

let WorksheetGridCommonDataInjectedPropsProvider = ({ children }) => {
  const dispatch = useDispatch();
  const data = useSelector((s) => s.worksheetGrid.commonData);
  const setValue = (opts) => dispatch(actions.setCommonDataValue(opts));
  const submit = () => {};
  const providerData = {
    data,
    setValue,
    submit,
  };
  return (
    <InjectedPropsProvider
      getProviderProps={(consumerProps, modifiers) =>
        getWorksheetGridCommonDataProviderProps(consumerProps, providerData, modifiers)
      }
    >
      {children}
    </InjectedPropsProvider>
  );
};

WorksheetGridCommonDataInjectedPropsProvider = withInjectedProps(WorksheetGridCommonDataInjectedPropsProvider);

export { WorksheetGridCommonDataInjectedPropsProvider };
export default WorksheetGridCommonDataInjectedPropsProvider;
